import React, { Component } from "react";
import "./CookieBanner.scss";

export default class CookieBanner extends Component {
  render() {
    const { 
      countryCode = '', 
      toggleSettings = () => {}, 
      bannerOpen = false, 
      handleOk = () => {}, 
      copy = { bannerLanguage: [], bannerOk: '' } 
    } = this.props;

    let base = "";
    if(typeof window !== "undefined") {
      base = window.location.host === "www.nikesb.com" ? "https://agreementservice.svs.nike.com" : "https://agreement.test.svs.nike.com";
    } else {
      base = process.env.BASE_URL === "https://www.nikesb.com" ? "https://agreementservice.svs.nike.com" : "https://agreement.test.svs.nike.com";
    }
    const privacyLink = `${base}/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.nikesb&country=${countryCode}&requestType=styled`;
    const bannerClasses = `cookie-banner ${bannerOpen ? 'open' : 'closed'}`;

    return (
      <div className={bannerClasses}>
        <p className="cookie-banner__copy copy copy--sans">
          {(copy && copy.bannerLanguage ? copy.bannerLanguage : []).map((component, i) => {
            const key = `banner:${i}`;
            switch(component && component.block ? component.block : '') {
              case "copy":
                return <React.Fragment key={key}>{component && component.copy ? component.copy : ''}</React.Fragment>;
              case "privacyLink":
                return <a href={privacyLink} target="_blank" rel="noopener noreferrer" key={key}>{component && component.copy ? component.copy : ''}</a>;
              case "settings":
                return <button onClick={toggleSettings} className="cookie-banner__link" key={key}>{component && component.copy ? component.copy : ''}</button>;
              default:
                return null;
            }
          })}
        </p>
        <button onClick={handleOk} className="cookie-banner__btn">{copy && copy.bannerOk ? copy.bannerOk : 'OK'}</button>
      </div>
    );
  }
}
